import { ItemInstance } from '@headless-tree/core';
import Typography from '@mui/material/Typography';
import React from 'react';
import { ChevronLeft } from 'shared/assets/icons';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';

import * as Styled from './type-header.style';

export type TypeHeaderProps = {
  item: ItemInstance<InternalTreeItem>;
  denseFormat?: boolean;
};

export const TypeHeader: React.FC<TypeHeaderProps> = ({
  item,
  denseFormat,
}) => {
  const toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    item.isExpanded() ? item.collapse() : item.expand();
  };

  return (
    <Styled.HeaderContainer $denseFormat={denseFormat}>
      <Typography variant="h6" component="span">
        {item.getItemData()?.name}
      </Typography>
      <IconButton
        icon={ChevronLeft}
        onClick={toggleOpen}
        rotation={item.isExpanded() ? -90 : 0}
        color={Colors.Default}
      />
    </Styled.HeaderContainer>
  );
};
